/*
 * Copyright 2023 Neckar IT GmbH, Mössingen, Germany
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package com.meistercharts.canvas.timer

import com.meistercharts.canvas.ChartRenderLoopListener
import com.meistercharts.canvas.ChartSupport
import it.neckar.open.time.BaseTimerImplementation
import it.neckar.open.unit.si.ms

/**
 * A timer support that uses the canvas render loop to execute the callbacks
 */
class CanvasBasedTimerImplementation : BaseTimerImplementation(), ChartRenderLoopListener {
  override fun render(chartSupport: ChartSupport, frameTimestamp: @ms Double, frameMonotonicMillis: @ms Double) {
    update()
  }
}
